import { SVGProps, Ref, forwardRef } from 'react';

export const FlameFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m13.135 1.333 1.154.705c3.827 2.339 5.036 5.625 5.253 8.303.079.968.029 1.853-.065 2.586a8 8 0 0 0 2.084-1.398c.479-.439.936-.934 1.284-1.486l.788-1.315 1.087 1.087c3.995 3.997 4.83 9.21 3.078 13.458-1.755 4.258-6.042 7.394-11.924 7.394-7.297 0-13.907-6.038-12.297-14.624.614-3.269 2.388-5.327 4.174-7.202 1.804-1.895 3.59-3.587 4.822-6.278z"
                fill="currentColor"
            />
        </g>
    </svg>
));
FlameFilledSize32Glyph.displayName = 'FlameFilledSize32Glyph';
